<template>
    <div class="exampleWrap">
        <div class="exampleBox">
            <!--遮罩-->
            <div class="exampleShadow topS"></div>
            <div class="exampleShadow bottomS"></div>
            <div class="left">
                <div class="leftListBoxWrap" :style="leftListBoxStyle">
                    <div class="leftListBox" v-for="i in 2" :key="i">
                        <div class="leftList" v-for="(item,index) in leftData" :key="index">
                            <div class="name">
                                {{item.name}} <span>{{item.work}}</span>
                            </div>
                            <div class="wordWrap" v-html="item.val"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="rightTitle">从没想过…与大数据有关系</div>
                <div class="rightList" v-for="(item,index) in rightData" :key="index"
                     @click="chooseExampleEvent(index)">
                    <span></span>
                    <p v-html="item.val"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "example",
        data() {
            return {
                /* 轮询 top 值 */
                leftListBoxStyle: {
                    top: 0
                },
                top: 0,
                // 定时器
                Interval: null,
                /*数据*/
                rightData: [
                    {val: "总想提前大概评估可能存在的风险并提前制定相应的策略？"},
                    {val: "优化传统行业的供应链并降低成本"},
                    {val: "更有效地制定营销方案"},
                    {val: "凭借既有经验判断证券市场走向？"},
                    {val: "传统车企面临如何转型难题"},
                    {val: "政务资源优化配置"},
                    {val: "提高险企的核心竞争力"},
                    {val: "新兴技术在驱动房地产行业走向全面智能化"},
                ],
                leftData: [
                    {
                        name: "赵先生", work: "某电商店主",
                        val: "P2P平台频频暴露各种各样的问题，对于P2P平台来说，其纯线上操作的" +
                            "特点使风险变得很大，风控的有效性是决定其经营的状况的重要因素，如果" +
                            "风控有效性比较差，面临的坏账压力就很大，会出现困难甚至跑路<br/>" +
                            "所以合法P2P平台要注重自身大数据的风控能力，避免让自己公司陷入困境，" +
                            "必须重视、合法善用大数据保护及发展内在能力"
                    },
                    {
                        name: "黄女士", work: "某公司财务",
                        val: "过往某些电商平台的刷单现象非常严重，这导致交易数据严重失真。网购" +
                            "伴随着“刷单”的报道屡见报道，这样的交易数据基础下呈现出来的风控能力可" +
                            "想而知，由于数据的真实性缺失导致风控能力严重缺陷<br/>" +
                            "美国很多大数据征信公司的错误率高达50%，垃圾进垃圾出，原因就在于数据" +
                            "类型及数据质量、所以要选用风控数据质量高的公司合作"
                    },
                    {
                        name: "弓先生", work: "某创业公司总经理",
                        val: "目前大数据主要来源于互联网，人们在网络中的表现并不能完全反映其真" +
                            "实的一面。相同的人群在不同场合呈现出来的特征是不一样的，一个内向的人" +
                            "可能在网上很活跃，互联网数据很难还原真实状态<br/>" +
                            "美国次贷危机后产生一种“策略性违约”行为--贷款主体有能力还款却利用他法" +
                            "套利，此行为虽有不良征信，但对信用报告影响有限，大数据风控也有客观存" +
                            "在的影响因素"
                    },
                    {
                        name: "李先生", work: "某公司部门主管",
                        val: "数据的有效性、合法性、真实性等相关因素决定了风险评估的准确性，只" +
                            "有满足了几大因素后，才有必要制定相应的策略，不然毫无意义，只会浪费资" +
                            "源或并发出其它不确定的重大问题<br/>" +
                            "这只是个人的一点看法，打造迎合用户需求的好产品为主，评估可能存在的" +
                            "风险为辅才是正确的企业发展途径"
                    },
                    {
                        name: "蔡先生", work: "某食品厂副厂长",
                        val: "供应链作为企业的核心网链，将彻底变革企业市场便捷、业务组合、商业" +
                            "模式和运作模式，如果供应链运转低下将是致命的，竞争力逐渐降低，成本不" +
                            "可控，资源分配没办法最优化<br/>" +
                            "利用大数据很好地优化整条供应链是最佳选择，从需求到客户手上的各个协同" +
                            "环节进行详尽地掌控，然后设计相应的运营优化方案，从而让成本降低"
                    },
                    {
                        name: "李女士", work: "某车企采购主管",
                        val: "采购成本是目前影响企业整个供应链成本的重要因素，传统的采购策略制" +
                            "定方式一方面考虑的影响因素不全面，另一方面受人为的采购经验影响较大，" +
                            "并没有从全盘数据客观分析并制定相应的决策<br/>" +
                            "利用大数据优化链条辅助智能决策，科学地选择供应商和分配资源，更好地控" +
                            "制企业成本是优化供应链的其中一个环节"
                    },
                    {
                        name: "池女士", work: "某企业财务",
                        val: "供应链协同等细分领域效率低下需要升级。生产、采购、仓储、销售、物流" +
                            "等价值链环节，内部外部经营环境要求企业快速作出供应链的运营决策，假设企" +
                            "业的效率低下，客户体验该有多糟糕<br/>" +
                            "让大数据赋能协同环节，建立信息化平台，提升供应链的效率，避免由于供应链" +
                            "跟不上而造成损失"
                    },
                    {
                        name: "梁先生", work: "某公司副总",
                        val: "企业应该从预测、资源获取、协同效率、供应链计划、库存优化、物流效率、" +
                            "产品设计、人才梯队及风险预警、供应链整合各个环节上进行优化，用最低成本" +
                            "达到最优的销售效果，给客户带来更佳的体验<br/>" +
                            "整个环节需要依托大数据为基础，不断地分析数据、优化数据，作用于整个供应" +
                            "链的细分领域，让企业的供应链变得数据可视化"
                    },
                    {
                        name: "张小姐", work: "某淘宝店主",
                        val: "原本不知道大数据是什么，利用大数据让店铺的转化率火箭式往上涨才见识到" +
                            "它的魅力，感觉这是以后电商平台必不可少的营销利器，就像石油一样，我的" +
                            "店铺需要定期加油<br/>" +
                            "从未想过，还可以这样运营店铺，这是在过去时代从未想过就在我们身边的" +
                            "数据组织起来还可以产生这样的作用，太酷了"
                    },
                    {
                        name: "张先生", work: "某宠物用品公司销售",
                        val: "自问我们的产品不错的！以往开户的流失特高，哪个环节出现了问题，一直" +
                            "找不出原因导致公司的获客转化率一直不理想。所以就想到从大数据方向改善业务" +
                            "状况，果不其然！找相关的大数据公司合作后，效果非常明显<br/>" +
                            "利用大数据从获客到转化至留存等完整的流程上针对流失的用户都作出相应的运营策" +
                            "略，使转化率有明显的提升"
                    },
                    {
                        name: "徐小姐", work: "某企业营销人员",
                        val: "作为传统的零售快消企业，最注重的就是快。可是相当长的一段时间里，旧的" +
                            "商品卖不出去，新的商品进来徒增库存，导致公司的库存积压越来越严重。资金" +
                            "和人事都出现里很大的变故，经同事的努力，最后重生<br/>" +
                            "以大数据为突破口优化营销方案，对营销的全流程进行梳理，对用户进行细分管理，然" +
                            "后进行不同的用户实现千人千面的智能营销。未来就是大数据时代"
                    },
                    {
                        name: "闻先生", work: "某创业公司合伙人",
                        val: "公司算是在快速增长的创业公司，但是已经到里第一个瓶颈期。想要继续扩大业" +
                            "务又使营收有稳健的增长，想到的就是使现有的业务营收继续增长，以及设计迎合市" +
                            "场需求的新产品<br/>" +
                            "依赖大数据搭建以用户为中心的运营体系，基于用户的细分多场景相应地设计和投放" +
                            "金融产品，营收和新产品都如愿地让公司更进一层楼，真的很开心！"
                    },
                    {
                        name: "田女士", work: "某证券公司分析师",
                        val: "传统的证券市场凭借经验以及相关人为分析进行决策成功率并不乐观，在宏观的" +
                            "经济领域里，个体能接触到的经济因素（或称因子）有限，所以能够大概率相对稳定" +
                            "地判断市场走向是难度系数较高的行为<br/>" +
                            "市场海量的商业数据也就是大数据，从银行到行为数据及互联网数据就凸显价值，机" +
                            "器学习+大数据+人为分析结合起来就能很好地帮助证券专家或机构公司决策"
                    },
                    {
                        name: "冀先生", work: "某金融公司部门经理",
                        val: "凭借个人或团体人为分析作出决策进行证券买卖，风险因素太高。避险、定价两大" +
                            "因素很难量化及评估，投资者无法获得太多关于资产、信贷、风险缓释安排等方面的" +
                            "信息和数据，需要看到更多的数据才能客观分析<br/>" +
                            "通过大数据的方法把公共数据和私人数据连接起来，利用联邦学习技术打破信息孤岛，" +
                            "投资者就能看到更多数据，作出更好的决策"
                    },
                    {
                        name: "张女士", work: "某投资机构经理",
                        val: "随着互联网的发展，证券行业已经进入一个大数据信息海洋的云时代。光大证券乌" +
                            "龙事件就说明一般投资者面对的是单一的电脑在操盘，此类”黑天鹅“事件或许只是A股" +
                            "市场的开始，针对此类事件的预警变得格外重要<br/>" +
                            "大数据技术是预防“黑天鹅”的重要手段。在处理证券数据时能加深对数据本身以及各" +
                            "类行为 与市场的理解，达到增加投资胜率的目的"
                    },
                    {
                        name: "余先生", work: "某科技公司合伙人",
                        val: "量化投资由于巨大收益，是大数据最早应用的领域，而其也符合大数据最重要的三" +
                            "大思维变革，随着互联网和移动互联网带来的信息化革命，个人投资者将能后轻松使用" +
                            "大数据获得实证支持，降低交易策略风险，增强投资能力<br/>" +
                            "大数据让科技公司有机会能够挑战传统的金融分析师和交易员，利用对多维度数据量化、" +
                            "整合，针对各个市场，面向不同用户的交易策略，科学稳定地投资"
                    },
                    {
                        name: "王先生", work: "某车企销售主管",
                        val: "车企以往通过市场调研机构了解消费者需求，大型车企每年在这方面的投入达亿元" +
                            "级。但传统线下调研存在样本量稀少，数据分析报告周期长，不能完整代表未来3-5年" +
                            "内的完整模型，同时存在产品定义不精准的缺陷<br/>" +
                            "利用大数据分多个领域精准决策，不仅可以拓宽汽车行业调研数据的广度和深度，从大" +
                            "数据中了解汽车行业市众多因素，提出更好地解决问题的方案和建议"
                    },
                    {
                        name: "易先生", work: "某车企资深员工",
                        val: "定位是企业任何战略规划重中之重的内容，一旦定位不准，将直接把企业推向悬崖" +
                            "边类似的案例在汽车圈举不胜举。车企需要通过微博、微信、点评网、评论版上海量的" +
                            "网络评论交互性大数据，需要建立网评大数据，找自身产品与竞品相比的优缺点<br/>" +
                            "通过大数据统计分析，进行科学的需求和产品价格走势预测，并针对不同的细分市场" +
                            "来实行动态定价和差别定价，从而使企业收益最大化"
                    },
                    {
                        name: "李先生", work: "某车企市场部经理",
                        val: "产品端车企最迫切解决的是未来问题。车企每年都要投入大量的经费用于研发，如想" +
                            "构建一个大体能覆盖主流市场的车型结构，研发费用肯定得百亿。问题是投入巨资打造的" +
                            "车型，一旦没能抓住用户的需求痛点，那对企业是致命的<br/>" +
                            "车企需要基于大量真实的用户口碑等构建的汽车大数据，助力车企研发设计出更适合用户" +
                            "需求的产品，帮助车企总结过去经验，预判未来周期的市场需求走势"
                    },
                    {
                        name: "张先生", work: "某车企销售主管",
                        val: "大数据极大程度地改变车企传统的营销方式，推动车企营销变革。以往的营销主要" +
                            "通过品牌传播，通过群体分析；在大数据时代，营销变得更加精准，更加有效，甚至让" +
                            "交易达成直接变成了现实，形成闭环，极大程度地提高营销的效率<br/>" +
                            "通过大数据分析用户的用户特征特征和产品的市场口碑现状，再制定有针对性的营销方" +
                            "案和营销战略，实现精准信息精准推送，更好地为用户服务和发展忠诚用户"
                    },
                    {
                        name: "雷女士", work: "政府工作人员",
                        val: "通过整合缺陷投诉信息，技术服务公告、找回信息等数据，对车辆各级缺陷建" +
                            "立知识图谱，进一步结合过往缺陷会商案例中专家评判结果，对汽车产品缺陷可" +
                            "能性提供判断，辅助决策<br/>" +
                            "技术驱动整合各渠道信息形成大数据技术，赋能产品质量监督检查政务信息平台" +
                            "更好更快地处理政务工作"
                    },
                    {
                        name: "傅先生", work: "某政府机构人员",
                        val: "汇集融合财政、国税、地税、人行、统计等数据资源，提供基于数据驱动的财" +
                            "政业务优化和科学决策，全流程贯穿财政监督与绩效评价，为政策和决策提供科学" +
                            "依据和量化支撑<br/>" +
                            "财政大数据平台的数据整合极大力度地方便了国家财政机关单位的提高办事效率与" +
                            "改善因决策的结果"
                    },
                    {
                        name: "丁先生", work: "政府部门技术人员",
                        val: "构建政务信息共享标准体系，协助所有有关部门数据资产，明确政务数据来源、" +
                            "关系、流向、被引用次数等重要信息，确保政务信息有序开放、共享、使用、形成" +
                            "统一的信息地图、把握数据资产状况，保障数据质量安全<br/>" +
                            "依托大数据技术构建的政务信息共享标准体系能确保政务数据的使用安全、清晰管" +
                            "理梳理数据资源"
                    },
                    {
                        name: "胡女士", work: "政府网络技术人员",
                        val: "舆情监测平台基于海量网络数据的实施分析，为政府提供舆情监控、热点事件公" +
                            "众情绪、网络造谣、虚假信息发布者筛选和定位等功能、拓宽政府获取社情民意的渠" +
                            "道，提升执政效率<br/>" +
                            "依据互联网大数据建立的舆情监测平台能让政务机关单位能快速便捷地知民意，提前" +
                            "预测或分析相关事件"
                    },
                    {
                        name: "范先生", work: "某资深保险销售",
                        val: "保险以服务经济社会与人民生活为己任，是一个服务性的行业，与其它行业存在" +
                            "较强的依存关系，绝大多数领域都依附在相应的产业链条之上，以运营与分析该产" +
                            "业链的风险数据为特色，从而获得在该产业链上的分工及市场地位。<br/>" +
                            "大数据时代的到来，可能从根本上颠覆保险业这种产业风险数据运营商的定位，产" +
                            "业大数据平台也可能把以前相对有壁垒的保险专业特色化为乌有"
                    },
                    {
                        name: "马先生", work: "某保险机构副总",
                        val: "行业与社会大数据平台的逐步形成，保险业将面临产业链纵向一体化的挑战，" +
                            "比如精算仍然是保险业的核心技术，但仔细分析，精算是基于某些经验分布假设之" +
                            "上的统计推断，当数据量超出一定量的时候，局限性仍然存在<br/>" +
                            "大数据时代的技术逻辑，是用归纳法获得经验规则预测未来，一切都将变得更加简" +
                            "单，变得完全可由机器智能取代"
                    },
                    {
                        name: "赵先生", work: "某资深保险分析师",
                        val: "复业以来，保险业快速发展，成为服务经济发展不可忽视的力量。但由于保险需" +
                            "要持证经营，行业开放度相对要小，与完全开放的新零售等服务业比，在信息化、数" +
                            "据化、智慧化的水平与能力上存在一定差距处在一个相对洼地<br/>" +
                            "需要引用具有的支持能力的大数据技术，优化保险企业的组织运营体系、将产业生态与竞" +
                            "争模式进化至最优状态"
                    },
                    {
                        name: "王女士", work: "某创业公司合伙人",
                        val: "保险科技创业大军在成本更低、风险更小、效率更高三项原则的引领下，技术体系" +
                            "与运营模式在不同行业之间迁移完全有可能；以新技术为引领的发展思路的转型，保险业" +
                            "的产业生态、竞争模式与行业文化将随之发生深刻改变<br/>" +
                            "大数据与人工智能是改变根本的技术革命。解决信息不充分、不对称的问题，整合资源、" +
                            "协调行动、科学决策的能力将成为险企的核心竞争力"
                    },
                    {
                        name: "焦先生", work: "某房地产公司副总",
                        val: "房地产公司老板买一块地，然后自己出资建设，其中需要施工队，建筑师，以及各" +
                            "种凭证，建好了经过检查后，正式可以进行售卖，至于是否能够大卖，是否能够赚钱只" +
                            "能听天由命<br/>" +
                            "有着大数据的辅助，那么大数据可以告诉建筑公司目前房地产市场的变化趋势，人们购" +
                            "买房子的趋势，材料价格变化的趋势等等"
                    },
                    {
                        name: "胡先生", work: "某建筑公司商务",
                        val: "很多房地产公司要求建筑公司进行垫资，也就是说建筑完工后，卖了房子才能将钱" +
                            "给建筑公司进行结算，如果遇到资金链断裂的的情况下，无论是建筑公司还是房地产公" +
                            "司都破产的风险<br/>" +
                            "利用大数据技术将各方面的数据统计起来，告诉建筑公司，这家房地产公司是否值得你" +
                            "垫资，避免不必要的风险"
                    },
                    {
                        name: "薛女士", work: "某地产公司销售总监",
                        val: "建造好了房子，需要有人买房地产公司才能够回血。可是一般小房地产公司买不起" +
                            "大火的地段，只能在偏远地区进行建造，很多时候需要个几年甚至十几年的时间才能将" +
                            "房子卖完，如果资金不够雄厚的公司很难坚持下去，销售风险太大<br/>" +
                            "大数据可以告诉房地产公司，目前的市场价是一个什么样的范围，有哪种销售模式是人" +
                            "们所喜欢的"
                    },
                    {
                        name: "贾女士", work: "某地产公司宣传人员",
                        val: "市场风险，房地产公司的竞争是十分激烈的，特别是小房地产公司，几乎都是拼刺刀" +
                            "的那种，你用降价销售，别人降得更狠，你觉得没利润了，别人还有大把的利润可以赚。" +
                            "市场就那么大，购买房子的人就那么多，拼不过别人，市场自然也就是别人的了<br/>" +
                            "依托大数据可以告诉买房人，你建筑的大概成本是多少，建筑时间是多久，使用的建筑" +
                            "材料好不好，建筑公司口碑怎么样"
                    },
                ]
            }
        },
        created() {
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
            /*举例轮播*/
            this.exampleSwiper();
        },
        methods: {
            scrollFun() {
                this.$animate(document.getElementsByClassName("exampleWrap")[0], "fadeInUp");
            },
            /*举例轮播*/
            exampleSwiper() {
                /*list*/
                let leftListBoxDom = document.getElementsByClassName("leftListBox")[0];
                let listHeight = leftListBoxDom.offsetHeight;
                this.Interval = setInterval(() => {
                    this.top += 1;
                    /*保证顺畅 位移元素高度 + 底部外边距 16px*/
                    if (this.top >= listHeight + 16) {
                        this.top = 0;
                    }
                    this.leftListBoxStyle.top = `${-this.top}px`;
                }, 40);
            },
            /*定位案例数据*/
            chooseExampleEvent(index) {
                let num = index * 4;
                this.top = document.getElementsByClassName("leftList")[num].offsetTop;
                this.leftListBoxStyle.top = `${-this.top}px`;
                clearInterval(this.Interval);
                this.exampleSwiper();
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
            /*清除定时器*/
            clearInterval(this.Interval);
        }
    }
</script>

<style lang="scss" scoped>
    .exampleWrap {
        width: 1200px;
        margin: 0 auto 63px;
        position: relative;
        height: 712px;

        .exampleBox {
            position: absolute;
            display: flex;
            top: -70px;
            width: 100%;
            height: 782px;
            padding: 0 0 17px 57px;
            z-index: 100;
            overflow: hidden;
            background: #fff;

            .exampleShadow {
                position: absolute;
                left: 24px;
                width: 555px;
                height: 100px;
                z-index: 100;
            }

            .topS {
                top: 0;
                background-image: linear-gradient(-180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.60) 54%, rgba(255, 255, 255, 0.00) 100%);
                border-radius: 10px;
            }

            .bottomS {
                bottom: 0;
                transform: rotate(-180deg);
                background-image: linear-gradient(-180deg, #FFFFFF 0%, rgba(255, 255, 255, 0.60) 54%, rgba(255, 255, 255, 0.00) 100%);
                border-radius: 10px;
            }

            .left {
                position: relative;
                width: 494px;
                margin-top: 17px;
                padding: 91px 18px 0;
                background: #F5F8FA;
                border: 1px solid #E2EAF0;
                border-radius: 10px;

                .leftList {
                    padding: 20px 20px 20px 31px;
                    margin-bottom: 16px;
                    border-radius: 4px;
                    background: #fff;

                    .name {
                        margin-bottom: 4px;
                        font-size: 14px;
                        color: #1B2D35;

                        span {
                            margin-left: 10px;
                            font-size: 12px;
                            color: #40B0FF;
                        }
                    }

                    .wordWrap {
                        opacity: 0.6;
                        margin-bottom: 4px;
                        font-size: 12px;
                        color: #152346;
                        text-align: justify;
                        line-height: 24px;

                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .right {
                flex: 1;
                padding: 77px 0 0 114px;

                .rightTitle {
                    margin-bottom: 100px;
                    font-size: 30px;
                    color: #152346;
                }

                .rightList {
                    display: flex;
                    align-items: center;
                    margin-bottom: 47px;
                    line-height: 22px;
                    cursor: pointer;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    span {
                        display: inline-block;
                        width: 12px;
                        height: 12px;
                        border-radius: 50%;
                        margin-right: 22px;
                        background: #22A5FF;
                    }

                    p {
                        font-size: 16px;
                        color: #152346;
                    }
                }
            }
        }

        .leftListBoxWrap {
            position: absolute;
            width: 456px;
        }
    }
</style>
